import React, { memo, useRef, forwardRef } from 'react';
import MaterialTable from "material-table";
import TableIcons from "../../utils/TableIcons";
import RefreshIcon from "@material-ui/icons/Refresh";
import SyncIcon from "@material-ui/icons/Sync";
import AddBox from "@material-ui/icons/AddBox";
import getEnvironment from "../../utils/getEnvironment";
import {
    Button,
    List,
    ListItem,
    ListItemText,
    Typography,
} from "@material-ui/core";
import useFilterData from '../../hooks/useFilterData';
import VisibilityIcon from '@material-ui/icons/Visibility';

const OfferTable = memo(({ 
    data,
    refetch,
    setSuccess,
    filterAdv
}) => {
    const { allOffer, allAdvertiser } = data;
    const { findAdvertiserName } = useFilterData();
    const env = getEnvironment();
    const tableRef = useRef();

    const findSubOfferName = (allOffers, subOfferId) => {
        const subOffer = allOffers.find(offer => offer.id === subOfferId)
        return subOffer ? subOffer.offerName : null
    }

    const advLookup = {};
    allAdvertiser.forEach(adv => {
        advLookup[adv.id] = adv.name;
    });

    const subOfferLookup = {};
    allOffer.forEach(offer => {
        offer.subOfferIds.forEach(subOffer => {
            subOfferLookup[subOffer] = findSubOfferName(allOffer, subOffer)
        })
    });

    const findSubOfferNames = (allOffers, subOfferIds) => {
        const list = [];
        subOfferIds.forEach(subOffer => {
            const sub = allOffers.find(elem => elem.offerId === subOffer)
            if(sub){
                list.push({name: sub.offerName, id: sub.offerId})
            }
        })

        return list
    }

    return (
       <>
         <MaterialTable
                title=""
                tableRef={tableRef}
                icons={TableIcons}
                columns={[
                    {title: 'Id', field: "id", hidden: true},
                    {
                        title: "Offer Name", field: "offerName",
                    },
                    {
                        title: "Offer URLs", field: "offerUrls",
                        render: (rowData) => (
                            <List dense style={{height: '250px', overflow: 'scroll'}}>
                                {rowData.offerUrls.map((item, index) => {
                                    return (
                                        <ListItem 
                                            key={item.id}
                                            divider
                                            alignItems={"flex-start"}
                                            disableGutters
                                        >
                                            <ListItemText disableTypography>
                                                <Typography variant="body2">
                                                    {item.url}
                                                </Typography>
                                            </ListItemText>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        )
                    },
                    {
                        title: "Advertiser", field: "advertiserId", lookup: advLookup, defaultFilter: filterAdv ? [filterAdv] : [],
                        render: rowData => findAdvertiserName(allAdvertiser, rowData.advertiserId),
                    },
                    {
                        title: "Sub Offers", field: "subOffer", lookup: subOfferLookup, defaultFilter: filterAdv ? [filterAdv] : [],
                        render: (rowData) => (
                            <List dense style={{height: '250px', overflow: 'scroll'}}>
                                {findSubOfferNames(allOffer, rowData.subOfferIds).map((item, index) => {
                                    return (
                                        <ListItem
                                            key={item.id}
                                            divider
                                            alignItems={"center"}
                                            disableGutters
                                        >
                                            <ListItemText disableTypography>
                                                <Typography variant="body2">
                                                    <a href={`/info/offers/${item.id}`}
                                                       target="_blank">
                                                        {item.name}
                                                    </a>
                                                </Typography>
                                            </ListItemText>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        )
                    },
                ]}
                data={allOffer.map(offer => ({
                    id: offer.offerId,
                    offerName: offer.offerName,
                    offerTag: offer.offerTag,
                    offerUrls: offer.offerUrls,
                    advertiserId: offer.advertiserId,
                    subOfferIds: offer.subOfferIds
                }))}
                actions={[
                    {
                        icon: () => <RefreshIcon/>,
                        tooltip: 'Refetch Data',
                        isFreeAction: true,
                        onClick: () => refetch()
                    },
                    {
                        icon: () => <VisibilityIcon/>,
                        tooltip: 'Edit Offer',
                        onClick: (event, rowData) => window.open(`/info/offers/${rowData.id}`)
                    },
                ]}
                options={{
                    addRowPosition: 'first',
                    filtering: true,
                    pageSize: 300,
                    pageSizeOptions: [300, 600, 800],
                    headerStyle: {
                        minWidth: 'auto',
                    },
                }}
            />
        </>
    );
        
});

export default OfferTable;